export default "__VITE_ASSET__BeMcb6nC__"